<template>
  <label class="ai-visibility-input">
    <span class="ai-visibility-input__label">{{ label }}</span>
    <span v-if="subtitle" class="ai-visibility-input__subtitle">{{ subtitle }}</span>
    <input
      :value="value"
      :type="type"
      :placeholder="placeholder"
      :class="{ 'ai-visibility-input__control--error': error }"
      @input="$emit('input', $event.target.value)"
      @keyup.enter="$emit('enter')"
    />
    <span v-if="error" class="ai-visibility-input__error">{{ error }}</span>
    <span v-else-if="helperText" class="ai-visibility-input__helper">{{ helperText }}</span>
  </label>
</template>

<script>
export default {
  name: 'FormTextInput',
  props: {
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      default: '',
    },
    helperText: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    error: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
  },
}
</script>

<style lang="scss" scoped>

.ai-visibility-input {
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 10px;
  color: var(--v-mainColor-base);
}

.ai-visibility-input__label {
  color: var(--v-mainColor-base);
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
}

.ai-visibility-input__subtitle,
.ai-visibility-input__helper {
  color: var(--v-gray2Color-base);
  font-size: 12px;
  letter-spacing: 0.12px;
  line-height: 1;
}

.ai-visibility-input input {
  width: 100%;
  height: 42px;
  border: 1px solid #DADADA;
  border-radius: 4px;
  background: var(--v-cardBg-base);
  color: var(--v-mainColor-base);
  font-size: 14px;
  line-height: 22px;
  outline-color: #DADADA;
  padding: 10px;

  &::placeholder {
    color: var(--v-darkGrayColor-base);
  }
}

.ai-visibility-input__control--error {
  border-color: var(--v-red11Color-base) !important;
}

.ai-visibility-input__error {
  color: var(--v-red11Color-base);
  font-size: 12px;
  letter-spacing: 0.12px;
  line-height: 1;
}
</style>
